import {grid, gridItem} from '~/design-system/foundations'
import {HgHeading} from '~/design-system/hg/components'
import DefaultVariant from '../DefaultVariant'
import {getHeadingContentTypeProps} from '../../utils'
import {type DefaultInnerHeroProps} from './types'

export function DefaultInnerHero(props: DefaultInnerHeroProps) {
  const {headline, subhead, breadcrumbs, alignment} = props
  return (
    <>
      <div
        className={grid({
          className: props.gridSlot(),
        })}
      >
        <div
          className={gridItem({
            size: 'heading',
            className: props.headingContainer(),
          })}
          ref={props.headingContainerRef}
        >
          <HgHeading
            {...getHeadingContentTypeProps({
              props,
              buttonVariant: 'tonal',
              alwaysStackedEmail: false,
            })}
            variation={'hero'}
            topSpacing={'s8'}
            breadcrumbs={breadcrumbs}
            className={props.heading()}
            headline={headline}
            subhead={subhead}
            alignment={alignment}
          />
        </div>
        <DefaultVariant {...props} />
      </div>
    </>
  )
}
